import { FormattedMessage } from 'react-intl';

// Components
import PermissionButton from 'components/buttons/PermissionButton';
import { useBulkDebtNotesModal } from 'components/modals/invoices/BulkDebtNotesModal';

// Types
import { InvoiceDataListItem } from 'types/invoices';

interface Props {
    invoices: InvoiceDataListItem[];
}

export const AddDebtNoteButton = ({ invoices }: Props) => {
    const { openBulkDebtNotesModal } = useBulkDebtNotesModal(invoices);

    const isEnabled = invoices.length > 0;

    const handleClick = () => {
        openBulkDebtNotesModal();
    };

    return (
        <div className="flex flex-row justify-end gap-2">
            <PermissionButton
                permissions={['UPDATE.INVOICES.BILLING_NOTES']}
                variant="outlined"
                size="small"
                disabled={!isEnabled}
                onClick={handleClick}
            >
                <FormattedMessage id="invoices.table-view.add-debt-note-button" />
            </PermissionButton>
        </div>
    );
};
